// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"761b5c62","977":"f1e04984"}[chunkId] + ".chunk.js";
};